import cx from '@vindr/utils/helpers/cx';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface ClearFilter {
  disabled?: boolean;
  onClick(...args: unknown[]): unknown;
  title?: string;
  className?: string;
}

const ClearFilter = ({ disabled, onClick, title, className }: ClearFilter): JSX.Element => {
  const { t } = useTranslation('Vindoc');
  title = title || t('Clear Filter');

  return (
    <div className={cx('filter-items flex items-end', className)}>
      <Button size="small" className="filter-btn" disabled={disabled} onClick={onClick}>
        {title}
      </Button>
    </div>
  );
};

export default ClearFilter;
